import React from 'react';
import { components } from 'react-select';
import type { SingleValueProps } from 'react-select';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

import AampeTooltip from '../shared/AampeTooltip/AampeTooltip';
// constants
import { SearchableSelectType } from './searchableSelect';

interface SelectSingleValueProps
    extends SingleValueProps<SearchableSelectType> {
    title?: string;
}

const SingleValue: React.FC<SelectSingleValueProps> = (props) => {
    const { title } = props;
    return (
        <components.SingleValue {...props}>
            <Label>
                {title && <LabelText>{title}:</LabelText>}
                {props.data.info ? (
                    <AampeTooltip title={props.data.label}>
                        <LabelText>{props.data.label}</LabelText>
                    </AampeTooltip>
                ) : (
                    <LabelText>{props.data.label}</LabelText>
                )}
                {props.data.trailingIcon && (
                    <LabelIcon>{props.data.trailingIcon}</LabelIcon>
                )}
            </Label>
        </components.SingleValue>
    );
};

const Label = styled.div(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    gap: aampeTheme.spacing4(2),
}));

const LabelText = styled.div({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

const LabelIcon = styled.div({});

export default SingleValue;
